import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { alert_error, alert_success } from "../../AppContext.js";
import axios from 'axios';
import { FaSun, FaMoon } from 'react-icons/fa'; // Import các icon từ react-icons

const Pickeroption = ({ showpicker, setshowpicker, chedoprofile, setchedoprofile, apikey, handleLogout }) => {
    const [text, setText] = useState('');
    const [lienketchay, setlienketchay] = useState('');
    const [nutxuly, setnutxuly] = useState(0);
    const [nutorder, setnutorder] = useState('✔️ Click to Confirm');
    const [thanhcong, setthanhcong] = useState('');
    const handleInputChange = (inputText) => {
        setlienketchay(inputText);
    };
    const dathang = response => {
        setnutorder('xác nhận');
        const info = response.data;
        const status = info.status;
        const message = info.message;

        if (status == 0) {
            alert_error(message);
        } else if (status == 4) {
            alert_success(message);
            handleLogout();
        } else {
            alert_success('Thành công');
            setthanhcong(message);
        }
    };

    const xacnhan = () => {
        setnutxuly(1);
        setnutorder('Please wait a moment 😊');
        console.log(chedoprofile);
        if (chedoprofile == null || !chedoprofile || !apikey) {
            setnutxuly(0);
            setnutorder('✔️ Click to Confirm');
            alert_error('Vui lòng chọn lựa chọn của bạn');
        } else if (chedoprofile == 'apikey') {
            setnutxuly(0);
            setnutorder('✔️ Click to Confirm');
            setthanhcong(apikey);
        } else {
            axios
                .post('https://hust.media/api/profile/profile.php', {
                    apikey: apikey,
                    chedo: 'profile',
                    option: chedoprofile,
                    lienketchay: lienketchay,
                })
                .then(response => {
                    setnutxuly(0);
                    console.log(response.data);
                    dathang(response);
                })
                .catch(error => alert_error(error));
        }
    };
    function saochep(value) {
        alert_success('Đã sao chép');
        window.saochepnative(value);

    };
    const [selectedOption, setSelectedOption] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const [options, setoptions] = useState([
        {
            id: '1', stt: '', label: 'Xem tên tài khoản',
            value: 'showusername', status: 'show', content: '', money: ''
        },
        {
            id: '2', stt: '', label: 'Thay tên tài khoản',
            value: 'username', status: 'show', content: '', money: ''
        }, {
            id: '3', stt: '', label: 'Xem mật khẩu',
            value: 'showpassword', status: 'show', content: '', money: ''
        },
        {
            id: '4', stt: '', label: 'Thay mật khẩu',
            value: 'password', status: 'show', content: '', money: ''
        },
        {
            id: '4', stt: '', label: 'Xem apikey',
            value: 'showapikey', status: 'show', content: '', money: ''
        },
        {
            id: '5', stt: '', label: 'Xóa tài khoản',
            value: 'delete', status: 'show', content: '', money: ''
        },
        {
            id: '6', stt: '', label: 'Đổi admin liên kết',
            value: 'change_ref', status: 'show', content: '', money: ''
        },
        {
            id: '7', stt: '', label: 'Bật tắt thông báo',
            value: 'change_noti', status: 'show', content: '', money: ''
        }
    ]);
    const handleFocus = () => {
        setIsOpen(true);
        console.log(123);
    };
    const handleBlur = () => {
        setIsOpen(false);
    };
    const handleMenuOpen = () => {
        setIsOpen(true);
    };
    const handleOptionChange = (selectedOption) => {
        setIsOpen(false);
        const selectedOptionpro = selectedOption.value;
        // setservice(selectedOptionpro);
        const selectedOptionok = options.find((option) => option.value == selectedOptionpro);
        setSelectedOption(selectedOptionok);
        console.log(selectedOptionok);
        setchedoprofile(selectedOptionok.value);
        // setcontent(selectedOptionok);
        // Thêm các hành động khác tại đây dựa trên lựa chọn của người dùng
    }
    useEffect(() => {
        if (chedoprofile) {
            const selectedOptionok = options.find((option) => option.value == chedoprofile);
            setSelectedOption(selectedOptionok);
            console.log(selectedOptionok);
        }

    }, [chedoprofile]);
    return (

        <div className="mt-2 mx-4  items-center justify-around " >

            <div className="mx-auto max-w-md rounded-2xl border divide-solid bg-gray-50 dark:bg-gray-300 ">
                <div style={{ zIndex: 1 }} onClick={() => setshowpicker(false)} className='flex justify-end mr-2 p-2'>
                    <button className='text-xl ml-auto'>✖</button>
                </div>
                <Select
                    classNamePrefix="Chọn 1 lựa chọn"
                    onFocus={handleFocus}
                    options={options}
                    value={selectedOption}
                    menuIsOpen={isOpen}
                    onBlur={handleBlur}
                    onMenuOpen={handleMenuOpen}
                    onChange={handleOptionChange}
                    isDisabled={false}
                    isLoading={false}
                    isClearable={true}
                    isRtl={false}
                    isSearchable={false}
                >
                </Select>
                {/* <div>Selected Value: {selectedValue}</div> */}
                {(chedoprofile == 'username' || chedoprofile == 'password') && (<>
                    <div className="text-center ">
                        <input
                            className='mt-2 mx-1 h-10  border border-gray-400 mb-2 px-4'
                            placeholder="Nhập vào đây"
                            onChange={(e) => handleInputChange(e.target.value)}
                            value={lienketchay}
                        />
                    </div>
                </>)}

                {(chedoprofile == 'change_ref') && (<>
                    <div className="text-center ">
                        <input
                            className='mt-2 mx-1 h-10  border border-gray-400 mb-2 px-4'
                            placeholder="username admin liên kết"
                            onChange={(e) => handleInputChange(e.target.value)}
                            value={lienketchay}
                        />
                    </div>
                </>)}

                <div className=" mb-2 ">
                    <button disabled={nutxuly == 1} onClick={xacnhan}
                        className='mt-2 flex break-inside bg-purple-400 hover:bg-purple-300 rounded-3xl px-8 py-2 mb-2 w-full dark:bg-purple-400 dark:text-white'>
                        <div className='flex items-center justify-between flex-1'>
                            {nutxuly == 1 &&
                                <div className="spinner-border" role="status">
                                </div>}

                            <span className='text-lg font-medium text-white'>
                                {nutorder} </span>
                                <div className="text-xl">
                                        {'\u27A4'}
                                    </div>
                        </div>
                    </button>
                    {
                        thanhcong &&
                        (<div className="ml-4 mr-4 " style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
                            {/* Existing code for the framed text */}
                            <div className="rounded-3xl border mt-2 ml-4 mr-4" style={{ borderRadius: 10, backgroundColor: '#ffffff' }}>
                                {/* Added div element with desired styles */}
                                <div className="flex flex-row">
                                    <div className="text-black  text-sm text-left mt-2 ml-2">Kết quả:</div>
                                    <button onClick={() => saochep(thanhcong)} className="ml-auto">
                                        <div className="text-black  text-sm ml-auto mt-2 mr-2">sao chép</div>
                                    </button>
                                </div>

                                <div className="text-lg text-center font-bold text-purple-400 mb-3 mx-2">
                                    {thanhcong}
                                </div>
                            </div>
                        </div>)
                    }
                </div>
            </div>
        </div>
    );
};



export default Pickeroption;
